<template>
  <ResizablePage>
    <template v-slot:content="conentProps">
      <v-container fluid v-bind:style="{ height: conentProps.tableHeight + 'px' }" class="overflow-y-auto" fill-height>
        <v-layout justify-center>
          <v-row style="max-width: 900px">
            <validation-observer style="width: 100%"
                                 class="px-5"
                                 ref="form_validation"
            >
              <v-form
                @submit.prevent="submit"
                :readonly="!editable">

                <v-expansion-panels multiple flat hover v-model="panels">
                  <v-expansion-panel>
                    <v-expansion-panel-header>{{ $t("view.contract.group.base") }}</v-expansion-panel-header>
                    <v-expansion-panel-content>

                      <v-row>
                        <v-col>
                          <validation-provider
                            v-slot="{ errors }"
                            name="view.contract.vehicle"
                            rules="required"
                          >
                            <VehicleField v-model="vehicle" :error-messages="errors" />
                          </validation-provider>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col>
                          <validation-provider
                            v-slot="{ errors }"
                            name="view.contract.name"
                            rules="required|max:100"
                          >
                            <v-text-field
                              v-model="name"
                              :counter="100"
                              :error-messages="errors"
                              :label="$t('view.contract.name')"
                              :clearable="editable"
                              required
                            ></v-text-field>
                          </validation-provider>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col>
                          <validation-provider
                            v-slot="{ errors }"
                            name="view.contract.name"
                            rules=""
                          >
                            <SubjectField v-model="subject"
                                          :error-messages="errors"
                                          :readonly="!editable"
                                          :clerable="editable"
                                          new-button
                                          v-on:new-subject="newSubject"
                            />
                          </validation-provider>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col>
                          <validation-provider
                            v-slot="{ errors }"
                            name="dialog.refueling.amount"
                            rules="required"
                          >
                            <AmountField
                              v-model="amount"
                              resource-label="dialog.refueling.amount"
                              :error-messages="errors"
                            />
                          </validation-provider>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col>
                          <validation-provider
                            v-slot="{ errors }"
                            name="view.contract.from_ts"
                            rules=""
                          >
                            <DateTimeField
                              v-model="fromTimestamp"
                              :readonly="!editable"
                              :clerable="editable"
                              :text-prefix="$t('view.contract.from_ts')"
                              :error-messages="errors" />
                          </validation-provider>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col>
                          <validation-provider
                            v-slot="{ errors }"
                            name="view.contract.to_ts"
                            rules=""
                          >
                            <DateTimeField
                              v-model="toTimestamp"
                              :readonly="!editable"
                              :clerable="editable"
                              :text-prefix="$t('view.contract.to_ts')"
                              :error-messages="errors" />
                          </validation-provider>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col>
                          <validation-provider
                            v-slot="{ errors }"
                            name="view.contract.from_place"
                            rules="max:200"
                          >
                            <v-text-field
                              v-model="fromPlace"
                              :counter="200"
                              :error-messages="errors"
                              :label="$t('view.contract.from_place')"
                              :clearable="editable"
                              required
                            ></v-text-field>
                          </validation-provider>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col>
                          <validation-provider
                            v-slot="{ errors }"
                            name="view.contract.to_place"
                            rules="max:200"
                          >
                            <v-text-field
                              v-model="toPlace"
                              :counter="200"
                              :error-messages="errors"
                              :label="$t('view.contract.to_place')"
                              :clearable="editable"
                              required
                            ></v-text-field>
                          </validation-provider>
                        </v-col>
                      </v-row>

                    </v-expansion-panel-content>
                  </v-expansion-panel>

                  <v-expansion-panel>
                    <v-expansion-panel-header>{{ $t("view.contract.group.plan") }}
                      <v-spacer />
                      <v-btn elevation="0" small class="mr-2" color="primary" max-width="120px"
                             v-on:click.stop="openGoogleMap" v-if="editable">
                        {{ $t("view.contract.btn_plan") }}
                      </v-btn>
                      <v-btn elevation="0" small class="mr-2" color="primary" max-width="120px"
                             v-on:click.stop="pasteRouteUrl" v-if="editable">
                        {{ $t("view.contract.btn_paste") }}
                      </v-btn>
                      <v-btn elevation="0" small class="mr-2" color="error" max-width="120px"
                             v-on:click.stop="cleaRoute" v-if="editable">
                        {{ $t("view.contract.btn_clear") }}
                      </v-btn>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>

                      <v-row>
                        <v-col>
                          <v-timeline v-if="plan !== null"
                                      align-top
                                      dense
                          >
                            <v-timeline-item v-for="(item, index) in plan.waypoints" :key="item.index"
                                             color="teal lighten-3"
                                             small
                            >
                              <v-row class="pt-1">
                                <v-col cols="2">
                                  <div class="text-caption">{{ routeDistanceSum(index) }}</div>
                                  <div class="text-caption">{{ routeDurationSum(index) }}</div>
                                </v-col>
                                <v-col>
                                  <strong>{{ routeItemName(index) }}</strong>
                                  <div class="text-caption">{{ routePart(index) }}</div>
                                </v-col>
                              </v-row>
                            </v-timeline-item>
                          </v-timeline>

                        </v-col>
                      </v-row>

                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-form>
            </validation-observer>
          </v-row>
        </v-layout>

        <v-snackbar
          v-model="showError"
          bottom
          light
          timeout="-1"
          color="red lighten-4"
        >
          {{ errorMessage }}

          <template v-slot:action="{ attrs }">
            <v-btn
              color="indigo"
              text
              v-bind="attrs"
              @click="showError = false"
            >
              Close
            </v-btn>
          </template>
        </v-snackbar>
      </v-container>
    </template>
  </ResizablePage>
</template>

<script>
import utils from "@/utils";
import ResizablePage from "@/components/ResizablePage";
import { DateTimeValue } from "@/dateTimeValue";
import DateTimeField from "@/components/fields/DateTimeField.vue";
import { Duration } from "luxon";
import VehicleField from "@/components/fields/VehicleField.vue";
import AmountField from "@/components/fields/AmountField.vue";
import SubjectField from "@/components/fields/SubjectField.vue";

export default {
  name: "ContractView",
  components: { SubjectField, AmountField, VehicleField, DateTimeField, ResizablePage },
  data() {
    return {
      editable: this.canWrite("contract"),
      canLeave: !this.canWrite("contract"),
      panels: [0, 1],

      vehicle: null,
      name: null,
      subject: null,
      fromTimestamp: new DateTimeValue(),
      toTimestamp: new DateTimeValue(),
      fromPlace: null,
      toPlace: null,
      plan: null,
      amount: null,

      googleUrl: null,
      record: null,

      showError: false,
      errorMessage: null
    };
  },

  methods: {
    toObject() {
      const object = {
        vehicleId: (this.vehicle !== null) ? this.vehicle.vehicleId : null,
        name: this.name,
        subjectId: (this.subject !== null) ? this.subject.subjectId : null,
        active: this.active,
        fromTimestamp: this.fromTimestamp.toJson("00:00"),
        toTimestamp: this.toTimestamp.toJson("23:59"),
        fromPlace: this.fromPlace,
        toPlace: this.toPlace,
        plan: this.plan,
        amount: null,
        currencyCode: null
      };

      if (this.amount !== null && this.amount.amount !== null) {
        object.amount = this.amount.amount;
        object.currencyCode = this.amount.currency;
      }

      let params = {
        module: "contract",
        object: object
      };

      if (!utils.isObjectEmpty(this.$store.state.data.record)) {
        params.id = this.record.contractId;
        object.contractId = this.record.contractId;
        object.lastChange = this.record.lastChange;
      }

      return params;
    },

    newSubject() {
      this.canLeave = true;
      this.$store.dispatch("data/recordPush", {
        router: this.$router,
        pushObject: this.toObject(),
        module: "subject",
        id: "new"
      });
    },

    async store() {
      if (this.$refs.form_validation.validate()) {

        const params = this.toObject();

        let response = await this.$store.dispatch("data/storeRecord", params);

        if (response.error) {
          this.showError = true;
          this.errorMessage = response.message;
        } else {
          this.canLeave = true;
          this.$router.close({ name: "data/contracts" });
        }
      }
    },

    async remove() {
      let params = {
        module: "contract",
        id: this.record.contractId
      };

      let response = await this.$store.dispatch("data/deleteRecord", params);

      if (response.error) {
        this.showError = true;
        this.errorMessage = response.message;
      } else {
        this.canLeave = true;
        this.$router.close({ name: "data/contracts" });
      }
    },

    cancel() {
      this.canLeave = true;
      this.$router.close({ name: "data/contracts" });
    },

    openGoogleMap() {
      if (this.googleUrl !== null)
        window.open(this.googleUrl, "_blank");
      else
        window.open("https://google.com/maps/dir/", "_blank");
    },

    pasteRouteUrl() {
      navigator.clipboard.readText().then(text => {
        if (text.startsWith("https://www.google.com/maps") || text.startsWith("https://google.com/maps") || text.startsWith("https://maps.app.goo.gl/"))
          this.googleUrl = text;
        this.recalcRoute();
      });
    },

    cleaRoute() {
      this.plan = null;
      this.googleUrl = null;
    },

    routeItemName(index) {
      return utils.formatRouteName(this.plan, index);
    },

    routePart(index) {
      if (index >= this.plan.parts.length)
        return "Konec";
      else {
        const part = this.plan.parts[index];

        return "Další zastávka " + utils.formatDistance(part.distance)
          + " ⦁ " + Duration.fromObject({ seconds: part.duration }).toFormat("h'h' m'm'");
      }
    },

    routeDistanceSum(index) {
      var distance = 0;

      for (var i = 0; i < index; i++)
        distance += this.plan.parts[i].distance;

      return utils.formatDistance(distance);
    },

    routeDurationSum(index) {
      var duration = 0;

      for (var i = 0; i < index; i++)
        duration += this.plan.parts[i].duration;

      return Duration.fromObject({ seconds: duration }).toFormat("h'h' m'm'");
    },

    recalcRoute() {
      if (this.googleUrl !== null) {
        this.$store.dispatch("data/computeRouteUrl", this.googleUrl)
          .then(response => {
            this.plan = response.data;

            if (this.plan != null && this.fromPlace == null && this.toPlace == null) {
              this.fromPlace = this.plan.waypoints[0].name;
              this.toPlace = this.plan.waypoints[this.plan.waypoints.length - 1].name;
            }
          });
      } else {
        this.plan = null;
      }
    }
  },

  watch: {
    "$store.state.data.record": function() {
      if (this.$store.state.data.module === "contract" && this.$store.state.data.record !== null) {
        let record = this.$store.state.data.record;

        if (record.contractId === undefined || record.contractId === null) {
          this.contractId = null;
          this.vehicleId = null;
          this.name = null;
          this.subject = null;
          this.fromTimestamp = new DateTimeValue();
          this.toTimestamp = new DateTimeValue();
          this.fromPlace = null;
          this.toPlace = null;
          this.plan = null;
          this.googleUrl = null;
          this.amount = { amount: null, currency: "EUR" };
          this.currencyCode = null;

          this.newObject = true;
        } else {
          this.contractId = record.contractId;
          this.vehicle = { vehicleId: record.vehicleId };
          this.subject = (record.subjectId) ? { subjectId: record.subjectId } : null;
          this.name = record.name;
          this.fromTimestamp = DateTimeValue.fromString(record.fromTimestamp);
          this.toTimestamp = DateTimeValue.fromString(record.toTimestamp);
          this.fromPlace = record.fromPlace;
          this.toPlace = record.toPlace;
          this.plan = record.plan || null;
          this.googleUrl = record.planUrl || null;
          this.amount = { amount: record.amount, currency: record.currencyCode || "EUR" };

          this.newObject = false;
        }

        this.record = record;
      }
    },

    "$store.state.data.activeEvent": function() {
      const e = this.$store.state.data.activeEvent;
      if (e != null && e.target === "view") {
        try {
          if (e.click !== undefined) {
            switch (e.click) {
              case "store":
                this.store();
                break;
              case "cancel":
                this.cancel();
                break;
              case "delete":
                this.remove();
                break;
            }
          }
        } finally {
          this.$store.dispatch("data/processEvents");
        }
      }
    }
  },

  mounted() {
    this.$store.dispatch("data/resetEvents");

    this.$store.dispatch("data/recordPop", { module: "contract" }).then(result => {
      if (!result) {
        if (this.$route.params.id === "new")
          this.$store.dispatch("data/fetchRecord", { module: "contract" });
        else
          this.$store.dispatch("data/fetchRecord", { module: "contract", id: this.$route.params.id });
      }
    });
  },

  async beforeRouteLeave(to, from, next) {
    if (this.canLeave)
      next();
    else {
      const answer = window.confirm(this.$t("view.leave_msg"));
      if (answer) {
        next();
      } else {
        next(false);
      }
    }
  }
};
</script>

<style lang="sass" scoped>
.normal-flag-move
  margin: -10px -5px !important
</style>
